import React, { useState, useCallback } from "react";
import { ExpandMore, FileCopy, Check } from "@mui/icons-material";
import {
  Box,
  Paper,
  Typography,
  Chip,
  IconButton,
  Tooltip,
  Divider,
  Collapse,
} from "@mui/material";
const CopyButton = ({ value }: { value: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();

      navigator.clipboard.writeText(value);

      setCopied(true);

      setTimeout(() => setCopied(false), 1500);
    },
    [value],
  );

  return (
    <Tooltip title={copied ? "Copied" : "Copy"}>
      <IconButton size="small" onClick={handleCopy}>
        {copied ? (
          <Check sx={{ fontSize: 16 }} />
        ) : (
          <FileCopy sx={{ fontSize: 16 }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton